<script setup>
import { computed } from 'vue';

import Spinner from '@/components/ui/Spinner.vue';

const props = defineProps({
  colorType: {
    type: String,
    required: false,
    default: 'default',
    validator: (value) => ['default', 'accent', 'secondary', 'close', 'soft'].includes(value),
  },

  type: {
    type: String,
    required: false,
    default: 'button',
    validator: (value) => {
      const buttonTypes = ['button', 'submit', 'reset'];

      return buttonTypes.includes(value);
    },
  },

  borderRadius: {
    type: Number,
    default: 8,
  },

  width: {
    type: String,
    default: '100%',
  },

  height: {
    type: Number,
    default: 40,
  },

  loading: {
    type: Boolean,
    required: false,
    default: false,
  },

  showWaiting: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const styles = computed(() => ({
  borderRadius: `${props.borderRadius}px`,
  width: props.width,
  height: `${props.height}px`,
}));
</script>

<template>
  <button
    :class="[`${colorType}-button`, { loading }]"
    :style="styles"
    :type="type"
    :disabled="loading"
  >
    <span
      v-if="loading"
      class="spinner"
    >
      <Spinner
        class="spinner__item"
        :class="{ 'spinner__item--center': !showWaiting }"
      />
      <template v-if="showWaiting">
        {{ $t('Waiting') }}
      </template>
    </span>
    <slot v-else />
  </button>
</template>

<style lang="scss" scoped>
button {
  position: relative;

  &.loading {
    pointer-events: none;
  }
}

.spinner {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;

  &__item {
    left: 10px;
    position: absolute;

    &--center {
      // (button-width(60px) - spinner-width(18px)) / 2
      left: 21px;
    }
  }
}
</style>
